module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai287-367fefaeaa4925b93b28e702c10e3c1d.jpg";